import React, { useEffect, useState, useRef } from "react";
import { Calendar } from "lucide-react";
import { DatePicker } from "./DatePicker";

interface DateRangeInputProps {
  value?: Date;
  onChange: (date: Date) => void;
  minDate?: Date;
  maxDate?: Date;
  placeholder?: string;
}

export function DateRangeInput({
  value,
  onChange,
  minDate,
  maxDate,
  placeholder = "Select date",
}: DateRangeInputProps) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (
        containerRef.current &&
        !containerRef.current.contains(e.target as Node)
      ) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleDateSelect = (date: Date) => {
    onChange(date);
    setIsOpen(false);
  };

  return (
    <div ref={containerRef} className="relative">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full h-8 px-2.5 text-[13px] text-fg bg-bg-elevated border border-bg3 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-prime/10 focus:border-prime transition-colors cursor-pointer hover:border-fg2 flex items-center gap-2"
      >
        <Calendar size={14} className="text-fg2 flex-shrink-0" />
        <span className="flex-1 text-left">
          {value ? value.toLocaleDateString() : placeholder}
        </span>
      </button>

      {isOpen && (
        <div className="absolute top-full right-0 mt-2 z-50 bg-bg-elevated shadow-lg rounded-lg border border-bg3">
          <DatePicker
            value={value}
            onChange={handleDateSelect}
            minDate={minDate}
            maxDate={maxDate}
          />
        </div>
      )}
    </div>
  );
}
